import React, { Fragment } from "react";

const EmployerEpisodesContainer = ({
  episode: { week, companydescriptionname, poster },
}) => {
  return (
    <Fragment>
      <div className="week-container">
        <p className="week-name">{week}</p>
      </div>
      <div className="week-info">
        <p className="industry">{companydescriptionname}</p>
      </div>
      <img
        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/employer_spotlight_images/${poster}`}
        className="week-image"
        alt=""
      />
    </Fragment>
  );
};

export default EmployerEpisodesContainer;
